<template>
  <div class="flex flex-col gap-6 items-start px-4 pb-8 pt-2">
    <p class="font-semibold text-sm">Detail Transaction</p>
    <div class="flex flex-col gap-3 px-3.5 py-3 border border-1 rounded-xl w-full mb-5">
      <div class="flex flex-col gap-0.5 w-full">
        <div class="flex flex-row justify-between gap-4 w-full">
          <p class="font-semibold text-sm">{{ withdrawInfo.wallet }}</p>
          <p class="text-xs">{{ withdrawInfo.date }}</p>
        </div>
        <div class="flex flex-row justify-between gap-4 w-full">
          <p class="text-GREY text-xs">ID : {{ withdrawInfo.id }}</p>
          <p class="text-GREY text-xs">{{ withdrawInfo.time }}</p>
        </div>
      </div>

      <div class="flex flex-col gap-2.5 relative w-full ">
        <div
          class="rounded-xl border border-1 flex flex-row justify-between items-center w-full px-3 py-2.5"
        >
          <div class="flex flex-col gap-0.5 items-start">
            <p class="font-medium text-xs">{{ withdrawInfo.sendToken }}</p>
            <p class="text-xs text-GREY">Change in</p>
          </div>
          <p class="text-lg font-medium">{{ withdrawInfo.sendAmount }}</p>
        </div>
        <div
          class="rounded-xl border border-1 flex flex-row justify-between items-center w-full px-3 py-2.5"
        >
          <div class="flex flex-col gap-0.5 items-start">
            <p class="font-medium text-xs">{{ withdrawInfo.recriveToken }}</p>
            <p class="text-xs text-GREY">Change to</p>
          </div>
          <p class="text-lg font-medium">{{ withdrawInfo.recriveAmount }}</p>
        </div>
        <div
          class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-WHITE w-8 h-8 rounded-full"
        >
          <font-awesome-icon
            class="p-2 black-icon"
            icon="fa-solid fa-arrow-down"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const isConnected = ref(true)

const props = defineProps({
  withdrawInfo: {
    type: Object,
    required: true
  },
})
const loading = ref(false)
</script>
